var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlashcardSetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9552 9.3V16.2C19.9552 17.8802 19.9552 18.7202 19.6282 19.362C19.3406 19.9265 18.8816 20.3854 18.3172 20.673C17.6754 21 16.8353 21 15.1552 21H9.33224C7.65209 21 6.81201 21 6.17027 20.673C5.60579 20.3854 5.14685 19.9265 4.85923 19.362C4.53225 18.7202 4.53225 17.8802 4.53225 16.2V8.58692C4.53225 8.43582 4.55337 8.28965 4.59281 8.1512C4.18801 7.76331 3.93906 7.21791 3.93906 6.61998C3.93906 5.44915 4.8882 4.5 6.05903 4.5H15.1552C16.8353 4.5 17.6754 4.5 18.3172 4.82698C18.8816 5.1146 19.3406 5.57354 19.6282 6.13803C19.9552 6.77976 19.9552 7.61984 19.9552 9.3Z",
    fill: "#93ABE6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.379944,
    width: 15.4229,
    height: 17,
    rx: 3,
    fill: "#6A84C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashcardSetIcon);
export default __webpack_public_path__ + "static/media/flashcard-set-icon.f85d2a9aa6f0955b1e45e7df7ff0ce7e.svg";
export { ForwardRef as ReactComponent };